import { createPixelTheme, createTheme } from '@pixel/core/styles';
import { alpha, lighten, darken } from '@pixel/core/styles';
export const createInternalTheme = _ref => {
  let {
    darkMode,
    theme
  } = _ref;
  let isDarkMode = Boolean(darkMode) && darkMode == true;
  const muiOptions = {
    palette: {
      mode: isDarkMode ? "dark" : "light"
    },
    components: {
      // Name of the component ⚛️
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true
        }
      },
      MuiButton: {
        defaultProps: {
          disableElevation: true
        }
      },
      MuiFormControl: {
        defaultProps: {
          //size: "small",
        }
      }
    }
  };
  muiOptions.palette.primary = {
    main: isDarkMode ? "#1872CC" : "#1872CC"
  };
  muiOptions.palette.secondary = {
    main: isDarkMode ? "#000000" : "#000000"
  };
  muiOptions.palette.success = {
    main: isDarkMode ? "#38B24A" : "#38B24A"
  };
  muiOptions.palette.warning = {
    main: isDarkMode ? "#F57D21" : "#F57D21"
  };
  muiOptions.palette.error = {
    main: isDarkMode ? "#E51414" : "#E51414"
  };
  muiOptions.palette.info = {
    main: isDarkMode ? "#5B6971" : "#5B6971"
  };
  muiOptions.palette.appBackground = {
    main: isDarkMode ? "#090e11" : "#F5F8FA"
  };
  const muiPixelTheme = createPixelTheme({
    mui: muiOptions
  });
  const {
    palette
  } = muiPixelTheme;
  const mergedTheme = createTheme(muiPixelTheme, {
    components: {
      MuiTab: {
        styleOverrides: {
          root: {
            color: muiPixelTheme.palette.secondary.main,
            "&.Mui-selected": {
              color: muiPixelTheme.palette.secondary.main
            }
          }
        }
      },
      MuiButtonBase: {
        styleOverrides: {
          root: {
            borderRadius: 4,
            textTransform: "none",
            boxShadow: "none",
            "&.Mui-focusVisible": {
              backgroundColor: palette.action.focus
            }
          }
        }
      },
      MuiButtonGroup: {
        styleOverrides: {
          groupedText: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: palette.action.hover,
              boxShadow: "none"
            }
          },
          groupedTextPrimary: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: alpha(palette.primary.light, 0.2)
            }
          },
          groupedTextSecondary: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: alpha(palette.secondary.light, 0.2)
            }
          },
          groupedOutlined: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: palette.action.hover,
              boxShadow: "0px 0px 0px 2px " + alpha(palette.action.active, 0.2)
            }
          },
          groupedOutlinedPrimary: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: lighten(palette.primary.light, 0.9),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.primary.main, 0.2)
            }
          },
          groupedOutlinedSecondary: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: lighten(palette.secondary.light, 0.9),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.secondary.main, 0.2)
            }
          },
          groupedContained: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: palette.action.hover,
              boxShadow: "0px 0px 0px 2px " + alpha(palette.action.active, 0.2)
            }
          },
          groupedContainedPrimary: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: darken(palette.primary.main, 0.2),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.primary.light, 0.2)
            }
          },
          groupedContainedSecondary: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: darken(palette.secondary.main, 0.2),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.secondary.light, 0.2)
            }
          }
        }
      },
      MuiFormControl: {
        styleOverrides: {
          size: "small"
        }
      },
      MuiButton: {
        styleOverrides: {
          // startIcon: {
          //   marginRight: "2px"
          // },
          text: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: palette.action.hover,
              boxShadow: "none"
            }
          },
          textPrimary: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: alpha(palette.primary.light, 0.2)
            }
          },
          textSecondary: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: alpha(palette.secondary.light, 0.2)
            }
          },
          outlined: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: palette.action.hover,
              boxShadow: "0px 0px 0px 2px " + alpha(palette.action.active, 0.2)
            }
          },
          outlinedPrimary: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: lighten(palette.primary.light, 0.9),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.primary.main, 0.2)
            }
          },
          outlinedSecondary: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: lighten(palette.secondary.light, 0.9),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.secondary.main, 0.2)
            }
          },
          outlinedInfo: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: lighten(palette.info.light, 0.9),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.info.main, 0.2)
            }
          },
          outlinedSuccess: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: lighten(palette.success.light, 0.9),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.success.main, 0.2)
            }
          },
          outlinedWarning: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: lighten(palette.warning.light, 0.9),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.warning.main, 0.2)
            }
          },
          outlinedError: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: lighten(palette.error.light, 0.9),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.error.main, 0.2)
            }
          },
          contained: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: palette.action.hover,
              boxShadow: "0px 0px 0px 2px " + alpha(palette.action.active, 0.2)
            }
          },
          containedPrimary: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: darken(palette.primary.main, 0.2),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.primary.light, 0.2)
            }
          },
          containedSecondary: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: darken(palette.secondary.main, 0.2),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.secondary.light, 0.2)
            }
          },
          containedInfo: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: darken(palette.info.main, 0.2),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.info.light, 0.2)
            }
          },
          containedSuccess: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: darken(palette.success.main, 0.2),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.success.light, 0.2)
            }
          },
          containedWarning: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: darken(palette.warning.main, 0.2),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.warning.light, 0.2)
            }
          },
          containedError: {
            boxShadow: "none",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: darken(palette.error.main, 0.2),
              boxShadow: "0px 0px 0px 2px " + alpha(palette.error.light, 0.2)
            }
          }
        }
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: "0.8rem",
            color: "#fff",
            backgroundColor: "#333"
          },
          arrow: {
            color: "#333"
          },
          tooltipArrow: {
            background: "#333"
          }
        }
      }
    }
  });

  //console.log("muiPixelTheme-", mergedTheme)

  return mergedTheme;
};
export default createInternalTheme;